import {Brand, formatEuros} from "@mytour/platform";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

type Props = {
  blocking: boolean;
  amountCentimes: number;
  smsCount: number;
  smsUnitPrice: number | null;
  onFixRecurringPayment: (type: "monthly" | "yearly") => void;
  onDismiss: () => void;
};

export function FailedSmsPaymentModal({
  blocking,
  amountCentimes,
  smsCount,
  smsUnitPrice,
  onFixRecurringPayment,
  onDismiss,
}: Props) {
  const amountEuros = formatEuros(amountCentimes / 100);

  return (
    <Modal
      isOpen={true}
      backdrop={blocking ? "static" : true}
      toggle={blocking ? undefined : onDismiss}
      autoFocus={false}
      centered
    >
      <ModalHeader
        close={blocking ? <></> : undefined}
        toggle={blocking ? undefined : onDismiss}
        className="mytour-header"
      >
        <Brand />
        Paiement en attente
      </ModalHeader>
      <ModalBody>
        <p style={{textAlign: "center"}}>
          <b>Merci de régler le paiement des notifications SMS</b>
        </p>
        <p style={{textAlign: "center"}}>
          {"Le paiement de votre consommation SMS a échoué."}
          <br />
          {"Merci de régulariser pour continuer à bénéficier du service."}
        </p>
        <p style={{textAlign: "center", color: "#6c757d", fontSize: "14px"}}>
          {formatSmsDetail(amountCentimes, smsCount, smsUnitPrice)}
        </p>
      </ModalBody>
      <ModalFooter>
        <div style={{textAlign: "center", margin: "auto", width: "100%"}}>
          <Button onClick={handleFixClick} color="primary">
            Régler {amountEuros} €
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );

  // SMS-only retries always have an existingOrderId at the backend level → RevolutModal
  // skips POST /api/order/, so the "monthly" fallback is never used for order creation.
  function handleFixClick() {
    onFixRecurringPayment("monthly");
  }
}

/** "42 SMS × 0,10 € = 4,20 €" or fallback "Notifications SMS 4,20 €" */
function formatSmsDetail(
  amountCentimes: number,
  smsCount: number,
  smsUnitPrice: number | null
): string {
  const amountEuros = formatEuros(amountCentimes / 100);
  if (smsCount > 0 && smsUnitPrice != null) {
    const unitPriceEuros = formatEuros(smsUnitPrice);
    return `${smsCount} SMS × ${unitPriceEuros} € = ${amountEuros} €`;
  }
  return `Notifications SMS ${amountEuros} €`;
}
